import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { StorageService } from '../services';
import CONSTANTS from '../constants';
import { PasswordAccessService } from '../services/password-access.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserPermissionGuard implements CanActivate {
	constructor(
		private storage: StorageService,
		private router: Router,
		private passwordAccessService: PasswordAccessService
	) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const user = this.storage.getUser();
		const routePath: string = (next.routeConfig || {} as any).path as string;

		if (!this.hasPermission(user.role, routePath)) {
			this.router.navigate(['/']);
			return of(false);
		}

		if (next.data['requirePassword']) {
			return this.passwordAccessService.confirmPassword({
				term: next.data['term']
			})
				.pipe(
					map((response: boolean) => {
						if (!response && (this.router.url === '/' || this.router.url === '')) {
							this.router.navigate(['/']);
						}

						return response;
					})
				);
		}

		return of(true);
	}

	private hasPermission(userRole: string, routePath: string): boolean {
		const permissions = (CONSTANTS.MANAGER_PERMISSIONS as any)[userRole];

		if (permissions) {
			for (const key in permissions) {
				if (
					permissions.hasOwnProperty(key) &&
					permissions[key].route === routePath
				) {
					return permissions[key].show || false;
				}
			}
		}

		return false;
	}
}
